import React from "react";
import CreateOrEditEditorComponent from "../../../pages/engagement_letter/CreateOrEditEditorComponent/CreateOrEditEditorComponent";
import { WordDocumentViewerProps } from "./WordDocumentViewer.types"
import styles from "./WordDocumentViewer.module.css";

const WordDocumentViewer: React.FC<WordDocumentViewerProps> = ({ preview }) => {
  return (
    <div className={styles.wordViewerWrapper}>
        <div className={styles.toolbar}>
            <div className={styles.fileTitle}>{preview?.name}</div>
        </div>
        <CreateOrEditEditorComponent
            docfilename={preview?.name!!}
            basedata={preview?.url}
            showheader={false}
            dataloader={true}
            forwizard={true}
            processedTemplateId={-1}
        />
    </div>
  );
};

export default WordDocumentViewer;
